export const environment = {
  production: false,
  /**
   * Solo si falla `GET tipos-solicitud` o no hay fila Â«Novedad de TrasladoÂ».
   * El id real debe resolverse con `TipoSolicitudNovedadTrasladoIdService` (ver `front-consumo-tipos-solicitud.md`).
   */
  ID_TIPO_SOLICITUD_NOVEDAD_TRASLADO_FALLBACK: 1,
  /** Texto en `TRL_CAT_TIPO_SOLICITUD.descripcion` para enlazar tipos de novedad de traslado. */
  TIPO_SOLICITUD_NOVEDAD_TRASLADO_DESCRIPCION: 'Novedad de Traslado',
  /** Si negocio define `codigo` único, se prioriza sobre la descripción (ej. `'NT'`). Dejar `''` para no usar. */
  TIPO_SOLICITUD_NOVEDAD_TRASLADO_CODIGO: '',
  /**
   * `true`: GET `tipos-novedad` sin `idTipoSolicitud` (todos los activos, coherente con Postman sin query).
   * `false` (QA/prod): filtra por TRL_P_TIPO_NOVEDAD_TIPO_SOLICITUD para el id resuelto.
   */
  TIPOS_NOVEDAD_LISTAR_SIN_FILTRO_TIPO_SOLICITUD: true,
  //HOST: 'http://localhost:8080',
  serviceURLQuoter: "https://oficinavirtualmp.coomeva.com.co/backend-cotizador/api",
  //HOST: "https://oficinavirtualmp.coomeva.com.co",
  // Proxy de mismo origen. El prefijo /ova evita que el Apache externo
  // intercepte directamente su Location temporal /ova-back.
  HOST: "/ova/ova-back",
  //HOST: "https://reverseqampdesa.coomeva.com.co",
  //HOST: 'https://reverseqa.coomeva.com.co',
  HOST_LINK_PAGO: "https://oficinavirtualmp.coomeva.com.co", //SE ESTABLECE COMO VARIABLE DE ENTORNO YA QUE ES UN PROYECTO EN PHP EXTERNO CON DIFERENTE LOCALHOST
  serviceURLMyQuoterIP: "https://oficinavirtualmp.coomeva.com.co/cotizador/api/cotizador",
  HOST_SECURE: 'https://secure.coomeva.com.co/coonectados',
  HOST_VISOR: 'https://oficinavirtualmp.coomeva.com.co/adm/#',
};
